import { shoppingGoodsItemStyle } from '_core/components/ShoppingGoodsItem/shoppingGoodsItemStyle'

export const articleStyle = theme => {
  const style = shoppingGoodsItemStyle(theme)

  return {
    cardMedia: style.cardMedia,
    cardContent: style.cardContent,

    date: {
      textAlign: 'right',
    },

    title: {
      margin: theme.spacing(0, 0, 2),
    },

    description: {
      margin: theme.spacing(2, 0),
    },

    content: {
      marginTop: theme.spacing(2),
      color: theme.variables.colors.contentText,
      overflowX: 'visible',

      // Prevent CKEditor/HTML content from breaking layout (e.g. wide images).
      '& .ck-content': {
        overflowWrap: 'anywhere',
        overflowX: 'visible',
      },
      '& .ck-content img': {
        display: 'block',
        maxWidth: '100%',
        height: 'auto',
      },
      '& .ck-content figure': {
        maxWidth: '100%',
        margin: theme.spacing(2, 0),
      },
      '& .ck-content figure.image img': {
        marginLeft: 'auto',
        marginRight: 'auto',
      },
      '& .ck-content iframe, & .ck-content video': {
        maxWidth: '100%',
      },
      '& .ck-content .table-wrapper, & .table-wrapper': {
        display: 'block',
        boxSizing: 'border-box',
        width: '100%',
        maxWidth: '100%',
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
      },
      '& .table-wrapper > figure.table': {
        display: 'block',
        boxSizing: 'border-box',
        maxWidth: 'none',
        overflow: 'visible',
      },
      '& .ck-content table, & .table-wrapper table': {
        borderCollapse: 'collapse',
      },
      '@media (max-width: 768px)': {
        '& .ck-content figure.table': {
          display: 'block',
          boxSizing: 'border-box',
          width: '100% !important',
          maxWidth: '100%',
          overflow: 'visible',
        },
        '& .ck-content table, & .table-wrapper table': {
          minWidth: 600,
          maxWidth: 'none',
        },
        '& .ck-content td, & .ck-content th, & .table-wrapper td, & .table-wrapper th': {
          whiteSpace: 'nowrap',
        },
      },
    },
    
    linking: {
      justifyContent: 'space-between',
      flexDirection: 'row-reverse',
    },
  }
}
